import React from 'react';
import Icon from '../../../components/AppIcon';

const bullets = [
  {
    title: 'GenAI (RAG, agentic systems, code & language models)',
    icon: 'Sparkles'
  },
  {
    title: 'Computer vision and simulation‑ML hybrids (digital twins)',
    icon: 'Camera'
  },
  {
    title: 'Secure MLOps on NVIDIA/on‑prem and Azure/GCP/AWS',
    icon: 'Server'
  },
  {
    title: 'Healthcare & regulated‑industry AI (HIPAA/GDPR‑aligned)',
    icon: 'Shield'
  }
];

const MasterySection = () => {
  return (
    <section className="py-20 relative text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center space-x-3 mb-8">
          <div className="flex items-center justify-center w-10 h-10 bg-white/10 rounded-lg backdrop-blur-sm border border-white/20">
            <Icon name="Target" size={20} color="white" />
          </div>
          <h2 className="text-4xl font-bold text-white">Applied AI/ML, GenAI systems, MLOps, and on‑prem/private deployments</h2>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 enterprise-shadow border border-white/20">
          <h3 className="text-2xl font-bold text-white mb-6">Mastery</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {bullets.map((item, idx) => (
              <div key={idx} className="flex items-start space-x-3">
                <div className="flex items-center justify-center w-8 h-8 bg-white/10 rounded-lg flex-shrink-0 border border-white/20">
                  <Icon name={item.icon} size={16} color="white" />
                </div>
                <p className="text-lg text-white/90">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MasterySection;


